import React, { Component } from 'react';
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import './TodoListStyles.css';

export default class TodoInput extends Component {
    render() {
        const {item, handleChange, handleSubmit, editItem, handleInputReset} = this.props

        return (
            <div className="card card-body my-3">
                <form onSubmit={handleSubmit} onReset={handleInputReset}>
                    {/*<h3 className="text-capitalize text-center">Todo Inputs</h3>*/}

                    <div className="input-group">   
                        {/*<div className="input-group-prepend">
                            <div className="input-group-text bg-primary text-white">
                                <i className="fas fa-book"></i>
                            </div>
                        </div>*/}
                        
                        <textarea name="message" rows="2" cols="30" className="form-control text-capitalize" placeholder="add a todo item" value={item} onChange={handleChange}/>
                        {/*<input type="text" className="form-control text-capitalize" placeholder="add a todo item" value={item} onChange={handleChange}/>*/}
                        
                        <div className="input-group-append">
                            <button type="reset" className="btn btn-danger clear-txt">
                                {editItem ? 'Cancel Edit' : 'Clear'}
                            </button>        
                        </div>
                    </div>

                    {/*Below uses conditional rendering for both the css and the text that will be displayed
                    when an item is being edited vs added for the first time
                    <button type="submit" className={editItem ? "btn btn-block btn-success mt-3" : "btn btn-block btn-primary mt-3"}>
                        {editItem ? 'Edit selected item' : 'Add item'}
                    </button>*/}

                    <AwesomeButton type={editItem ? "secondary" : "primary"}
                        onPress={() => {
                            handleSubmit();
                        }}
                        className="btn-block mt-3">
                            {editItem ? 'Edit selected item' : 'Add item'}
                    </AwesomeButton>
                </form>
            </div>
        )
    }
}